import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import Abnormal from '@home/components/Abnormal';

import AddShortcutCard from '../AddShortcutCard';
import ShortcutCard from '../ShortcutCard';
import { getUrlCollectionItemKey } from '@home/utils/urlCollectionData';

import type { IUrlCollectionItem } from '@home/types/urlCollection';

import './index.scss';

interface IShortcutsGridProps extends IBaseProps {
  loading: boolean;
  items: IUrlCollectionItem[];
  showAddCard?: boolean;
  onItemClick?: (item: IUrlCollectionItem) => void;
  onAddClick?: () => void;
}

const ShortcutsGrid: React.FC<IShortcutsGridProps> = (props) => {
  const { style, className, loading, items, showAddCard = false, onItemClick, onAddClick } = props;
  const { formatMessage } = useIntl();
  const isEmpty = !loading && items?.length === 0;

  return (
    <div
      style={style}
      className={classnames('dbh-shortcuts-grid', className, {
        'dbh-shortcuts-grid--loading': loading,
        'dbh-shortcuts-grid--empty': isEmpty,
      })}
    >
      <Abnormal
        style={{ height: 230 }}
        isLoading={loading}
        isNoData={isEmpty}
        nodataMsg={formatMessage({
          id: 'dbh_url_collection_shortcuts_empty',
          defaultMessage: 'Save your favourite pages and use one click to go!',
        })}
        component={items.map((item) => {
          return <ShortcutCard key={getUrlCollectionItemKey(item)} item={item} onClick={onItemClick} />;
        })}
      />
      {!loading && showAddCard && <AddShortcutCard onClick={onAddClick} />}
    </div>
  );
};

export default ShortcutsGrid;
